import React, { useState, useEffect } from "react";
import axios from "axios";
import Spinner from "@/svg/Spinner";
import "@/styles/ScoreTypesStats.css";
import ScoreTypesStatsListView from "@/components/ScoreTypesStats/ScoreTypesStatsListView";
import ScoreTypesStatsTableView from "@/components/ScoreTypesStats/ScoreTypesStatsTableView";
import ScoreTypesStatsGraphicView from "@/components/ScoreTypesStats/ScoreTypesStatsGraphicView";
import ScoreTypesStatsViewsButton from "@/components/ScoreTypesStats/ScoreTypesStatsViewsButton";
// TODO se deberia mostrar el alias en vez del hoyo si existe
const ScoreTypesStats = ({ competitionId, competitionName, view, selectedRoundId = null }) => {
    var _a;
    const [started, setStarted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rounds, setRounds] = useState([]);
    const [roundSelected, setRoundSelected] = useState(null);
    const [data, setData] = useState(null);
    const [visualizationType, setVisualizationType] = useState('table');
    const [errorMessage, setErrorMessage] = useState("");
    const startLoading = () => {
        setStarted(true);
        setLoading(true);
    };
    useEffect(() => {
        if (!started)
            return;
        if (selectedRoundId) {
            setRoundSelected(selectedRoundId);
        }
        else {
            setErrorMessage("");
            axios.get(`/stats/rounds/${competitionId}`)
                .then((response) => {
                setRounds(response.data);
                if (response.data.length > 0 && response.data[0].roundId) {
                    setRoundSelected(response.data[0].roundId);
                }
            })
                .catch(() => {
                setRounds([]);
                setRoundSelected(null);
                setErrorMessage("Ha ocurrido un error al obtener los resultados destacados");
            })
                .finally(() => {
                setLoading(false);
            });
        }
    }, [started]);
    useEffect(() => {
        if (!started || !roundSelected)
            return;
        setLoading(true);
        setErrorMessage("");
        axios.get(`/stats/scoreTypes/${roundSelected}`)
            .then((response) => {
            setData(response.data);
        })
            .catch(() => {
            setData(null);
            setErrorMessage("Ha ocurrido un error al obtener los resultados destacados");
        })
            .finally(() => {
            setLoading(false);
        });
    }, [roundSelected, started]);
    const currentRoundNumber = ((_a = rounds.find(({ roundId }) => roundId === roundSelected)) === null || _a === void 0 ? void 0 : _a.roundNumber) || undefined;
    return (React.createElement("div", { className: "scoreTypesStatsComponent" },
        React.createElement("h3", null, "Resultados destacados"),
        !started ?
            React.createElement("button", { className: "ui primary button", onClick: startLoading }, "Cargar resultados destacados")
            :
                React.createElement(React.Fragment, null,
                    "" !== errorMessage &&
                        React.createElement("div", { className: "ui red message" },
                            React.createElement("p", null, "Ha ocurrido un error al obtener los resultados destacados")),
                    loading ?
                        React.createElement(Spinner, null)
                        :
                            React.createElement("div", null,
                                React.createElement("div", { className: `buttonsHeaderContainer ${!selectedRoundId && rounds.length > 1 ? '' : 'justifyEnd'}` },
                                    !selectedRoundId && rounds.length > 1 && (React.createElement("div", { className: "roundButtonsContainer" }, rounds.map(({ roundNumber, roundId }) => {
                                        return React.createElement("button", { key: roundId, className: `ui button ${roundSelected === roundId ? 'primary' : ''}`, onClick: () => setRoundSelected(roundId) },
                                            "Jornada ",
                                            roundNumber);
                                    }))),
                                    data && !(Array.isArray(data) && 0 === data.length) &&
                                        React.createElement("div", { className: "groupBySelector" },
                                            React.createElement("div", { className: "ui icon buttons" },
                                                React.createElement(ScoreTypesStatsViewsButton, { icon: React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" },
                                                        React.createElement("path", { fill: "currentColor", d: "M3 3h18v18H3zm2 2v2h2V5zm4 0v2h10V5zm-4 4v2h2V9zm4 0v2h10V9zm-4 4v2h2v-2zm4 0v2h10v-2zm-4 4v2h2v-2zm4 0v2h10v-2z" })), title: "Ver en tabla", selectedVisualizationType: visualizationType, setVisualizationType: setVisualizationType, buttonVisualizationType: "table" }),
                                                React.createElement(ScoreTypesStatsViewsButton, { icon: React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" },
                                                        React.createElement("path", { fill: "currentColor", d: "M3 19v-2.077h2.077V19zm4.846 0v-2.077H21V19zM3 13.038v-2.077h2.077v2.077zm4.846 0v-2.077H21v2.078zM3 7.077V5h2.077v2.077zm4.846 0V5H21v2.077z" })), title: "Ver en lista", selectedVisualizationType: visualizationType, setVisualizationType: setVisualizationType, buttonVisualizationType: "list" }),
                                                React.createElement(ScoreTypesStatsViewsButton, { icon: React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" },
                                                        React.createElement("path", { fill: "currentColor", d: "M3 3v18h18v-2H5V3zm4 14h3V9H7zm5 0h3V5h-3zm5 0h3v-6h-3z" })), title: "Ver en gr\u00E1fica", selectedVisualizationType: visualizationType, setVisualizationType: setVisualizationType, buttonVisualizationType: "graphic" })))),
                                React.createElement("div", null, data &&
                                    React.createElement("div", null, (Array.isArray(data) && 0 === data.length) ?
                                        React.createElement("div", { className: "ui message emptyHighlightedResultsMessage" },
                                            React.createElement("p", null, "Todav\u00EDa no hay resultados destacados"))
                                        :
                                            React.createElement("div", { className: "textScoreTypesContainer" }, visualizationType === 'graphic' ?
                                                React.createElement(ScoreTypesStatsGraphicView, { data: data })
                                                : visualizationType === 'table' ?
                                                    React.createElement(ScoreTypesStatsTableView, { data: data, competitionName: competitionName, roundNumber: currentRoundNumber, view: view })
                                                    :
                                                        React.createElement(ScoreTypesStatsListView, { data: data }))))))));
};
export default ScoreTypesStats;
